import type { ReactNode } from "react";

import { Box, SxProps, Theme } from "@mui/material";

import { BodyTextSmall, SubtitleText } from "~/components/Typographies";

interface SettingsSectionProps {
	children: ReactNode;
	description?: string;
	id?: string;
	sx?: SxProps<Theme>;
	title: ReactNode;
}

const SettingsSection = ({ children, description, id, sx, title }: SettingsSectionProps) => (
	<Box id={id} sx={[{ mb: 6 }, ...(Array.isArray(sx) ? sx : [sx])]}>
		<Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1, pb: 1.25 }}>
			<SubtitleText bold>{title}</SubtitleText>
			{description && (
				<BodyTextSmall color="text.secondary" sx={{ mt: 0.5 }}>
					{description}
				</BodyTextSmall>
			)}
		</Box>
		{children}
	</Box>
);

export default SettingsSection;
